import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { Harness, HarnessType } from '@fc-core/models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@ApiService({
  baseName: 'harness',
})
export class HarnessApiService extends BaseApiService {
  static harnessIconDictionary = {
    [HarnessType.OBD2YCable]: 'assets/icons/harness/obd-2.svg',
    [HarnessType.OBD2Cable]: 'assets/icons/harness/obd-2.svg',
    [HarnessType.J1939Cable]: 'assets/icons/harness/j-1939.svg',
    [HarnessType.J1939YCable]: 'assets/icons/harness/j-1939.svg',
    [HarnessType.J1708Cable]: 'assets/icons/harness/j-1708.svg',
    [HarnessType.J1708YCable]: 'assets/icons/harness/j-1708.svg',
    [HarnessType.Wire3]: 'assets/icons/harness/3-wire.svg',
  };

  constructor(private http: HttpClient) {
    super();
  }

  getHarnessIcon(type: HarnessType): string {
    return HarnessApiService.harnessIconDictionary[type];
  }

  load(id: number): Observable<Harness> {
    return this.http.get<Harness>(this.getUrl(id));
  }

  validateHarness(serial: string, vehicleId?: number): Observable<Harness> {
    let params: HttpParams = new HttpParams();
    if (vehicleId) params = params.append('vehicle_id', vehicleId);
    return this.http.get<Harness>(this.getUrl() + `s/${serial}/validate/`, {
      params,
    });
  }
}
